import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_dfu92850: FaireBrandEntity = {
  token: "b_dfu92850",
  type: "brand",
  name: "Pippi Post",
  avatarUrl:
    "https://cdn.faire.com/fastly/31125757ea1d42dbabae83969d4eb1ced58d56d190bed282625d5a918fa616b7.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/5b9714af2abba3fad40e4f9d9f6ef7ecdac4b2ed33336929428d2b450c2b01b8.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/31125757ea1d42dbabae83969d4eb1ced58d56d190bed282625d5a918fa616b7.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/5b9714af2abba3fad40e4f9d9f6ef7ecdac4b2ed33336929428d2b450c2b01b8.jpeg",
  location: "Bowling Green, KY, USA",
  minimumOrderDollars: 137,
  rating: 4.9,
  reviewCount: 398,
  productCount: 926,
  isTopShop: true,
  isInsider: true,
  description:
    'Pippi Post is a joyful bookish and stationery brand designed to foster a love of reading, snail mail, and making the ordinary moments magical! Designed by Alexa Zurcher, a Utah mom of four, Pippi Post inspires entire families and educators to embrace their creativity, curl up with a good book, and bring inspiration to every day.\n\n*Please include "Pippi Post" in any e-commerce listing or social media post promoting product*\n\nBrowse our current catalog at pippipost.com/wholesale-catalog',
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:45:02.442Z",
    importedBy: "entity-db-cli",
  },
};
